import React from "react";
import Accordion from "../Accordion/Accordion";
import { CustomDiv } from "../../style/shared";

import Advertise from "../../assets/Ads/vertical2.jpeg";
import { CustomLinkBut, ADImage } from "../../style/Dashboard";
import { verifyAuth } from "../../authverify";
import { useHistory } from "react-router-dom";
import "../Sidebar/sidebar.css";
export const Dashboard = ({ verticalCreative }) => {
  console.log(">>vert", verticalCreative);
  const history = useHistory();

  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }
  return (
    <div style={{ width: "95%" }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: '80%'}}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "10px",
            }}
          >
            <Accordion />
          </div>
          <div style={{ marginTop: 0 }}>
            <CustomLinkBut
              className="button"
              style={{ marginBottom: "15px" }}
              to="/People/Consultation"
            >
              Next
            </CustomLinkBut>
          </div>
        </div>
        <div style={{ width: '20%'}}>
          <iframe
            style={{ height: "728px", width: "100%" }}
            srcDoc={verticalCreative}
          />
        </div>
      </div>
    </div>
  );
};
